import { DatePicker, InputErrorMessage } from '@commenda/kakashi';
import { MoleculeCard } from '../helpers/MoleculeCard';
import { MoleculeCardTitle } from '../helpers/MoleculeCardTitle';

type EntityFormationDatePickerProps = {
  error?: string;
  disabled?: boolean;
  formationDate: string;
  setFormationDate: (date: string) => void;
};

export function EntityFormationDatePicker({
  disabled,
  formationDate,
  setFormationDate,
  error,
}: EntityFormationDatePickerProps) {
  return (
    <MoleculeCard>
      <MoleculeCardTitle title="Formation date" />
      <DatePicker
        disableInput={disabled}
        placeholder="Formation date"
        setDate={setFormationDate}
        date={formationDate}
        _triggerClassName="h-11"
      />
      {error && <InputErrorMessage message={error} />}
    </MoleculeCard>
  );
}
